export enum EPaymentType {
  Cash = 1,
  Cheque,
  Credit_Card,
  Bill_From_Office,
  Debit,
  Other,
}
